<div class="image-container">
  <div
    class="dish-image uploaded-image inset-border"
    *ngFor="let img of imageArray; let i = index"
    (mouseover)="showDeleteBin(i, 'old')"
    (mouseout)="hideBin()"
    [ngClass]="isThumbNail(thumbNail, img, 0) ? 'thumbnail' : ''"
    (click)="selectThumbNail(img, 0)"
  >
    <img class="img conserve-img-aspect-ratio" [src]="img" alt="check-icon" />
    <img [src]="images.CHECKED" alt="check-icon" class="checkimg" [ngClass]="!isThumbNail(thumbNail, img,0)? 'hidden':''">
    <div
      class="delete-bin"
      *ngIf="!cmmView"
      (click)="deleteDishImage(img, i)"
    >
      <img [src]="images.CROSS_2X" alt="close" />
    </div>
  </div>

  <ng-container *ngIf="fileList.length">
    <!-- start -->
    <div
      class="dish-image uploaded-image"
      *ngFor="let img of urls; let i = index"
      (mouseover)="showDeleteBin(i, 'new')"
      (mouseout)="hideBin()"
      [ngClass]="isThumbNail('', img.name, 1) ? 'thumbnail' : ''"
      (click)="selectThumbNail(img.name, 1)"
    >
      <img class="img" [src]="img.path" alt="image" />
      <div class="delete-bin" *ngIf="!cmmView" (click)="deleteImage(i)">
        <img [src]="images.CROSS_2X" alt="close" />
      </div>

      <!-- end -->
    </div>
  </ng-container>

  <div
    class="dish-image image-editor-{{useImageEditor}}" (click)="allowImageEditor() ? openImageEditor() : null"
    [ngClass]="cmmView ? 'disable' : ''"
    [ngStyle]="((fileList?.length || 0) + (imageArray?.length || 0)) >= maxImageCount ? { display: 'none' } : ''"
  >
    <div *ngIf="!useImageEditor">
      <nz-upload
        nzListType="picture-card"
        [nzShowUploadList]="showUploadList"
        [(nzFileList)]="fileList"
        [nzShowButton]="fileList.length < 4"
        [nzBeforeUpload]="beforeUpload"
        [nzMultiple]="true"
        [nzDisabled]="cmmView"
      >
        <span style="font-size: 40px">+</span>
      </nz-upload>
    </div>
    <div *ngIf="useImageEditor">
      <span style="font-size: 40px;">+</span>
    </div>
  </div>
</div>
